import React from 'react';
import { OrdersView } from '../components/OrdersView';
import { useWarehouseAppContext } from '../hooks/useWarehouseAppContext';

export const OrdersViewPage: React.FC = () => {
  const { selectedOrder } = useWarehouseAppContext();

  if (!selectedOrder) {
    return null;
  }

  return <OrdersView order={selectedOrder} />;
};
